import { render, staticRenderFns } from "./BillingCodes.vue?vue&type=template&id=7a746188&scoped=true&"
import script from "./BillingCodes.vue?vue&type=script&lang=js&"
export * from "./BillingCodes.vue?vue&type=script&lang=js&"
import style0 from "./BillingCodes.vue?vue&type=style&index=0&id=7a746188&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a746188",
  null
  
)

export default component.exports